<div class="p-6 pl-4">
  <div class="ml-16">
    <a [routerLink]="['/auth']" class="flex items-center gap-2 text-[#0A4E8F] text-[16px] font-bold">
      <div>
        <span class="fi fi-rr-arrow-small-left text-[32px] text-[#0A4E8F] leading-none flex items-center"></span>
      </div>
      Volver
    </a>
  </div>
</div>

<div class="flex justify-center">
  <div class="text-center w-[392px] mt-12 sm:mt-16">
    <h2 class="text-[22px] sm:text-[26px] md:text-[28px] font-extrabold text-[#0A4E8F]">
      Ingresar nueva contraseña
    </h2>

    <p class="text-[#272B34] text-[16px] mt-2 font-semibold">
      <span class="whitespace-nowrap">Crea una nueva contraseña segura para acceder </span>
      <span class="block">a tu cuenta.</span>
    </p>

    <div class="mt-6">
      <div class="flex flex-col gap-2 ">
        <app-input type="password" label="Nueva contraseña" [control]="passwordFirstControl" placeholder="Ingresar" />
        <app-input type="password" label="Confirmar nueva contraseña" [control]="passwordSecondControl"
          placeholder="Ingresar" />
      </div>

      <div class="mt-6">
        <app-button [type]="'loader'"
        [disabled]="passwordFirstControl.invalid || passwordSecondControl.invalid || !isPasswordMatch()"
          [size]="'xLarge'" text="Confirmar nueva contraseña" [loading]="loading" (click)="recoveryPassword()"
          (keydown.enter)="recoveryPassword()" />
      </div>
    </div>
  </div>
</div>